export function transformIcon(logPlusIcon: string): string {
	switch (logPlusIcon) {
		case "account": return "person";
		case "account-circle": return "account-circle";
		case 'album': return 'album';
		case 'alert-circle': return 'error';
		case 'alert-octagram': return 'new_releases';
		case 'alert-triangle': return 'warning';
		case 'apple-icloud': return 'cloud';
		case 'arrow_up': return 'north';
		case 'arrow-collapse-down': return 'south';
		case 'arrow-down': return 'south';
		case 'arrow-right': return 'east';
		case 'arrow-expand': return 'call_split';
		case 'bell': return 'notifications';
		case 'bolt-circle': return 'offline_bolt';
		case 'briefcase': return 'work';
		case 'brush': return 'brush';
		case 'calendar': return 'event';
		case 'calendar-remove': return 'event_busy';
		case 'calendar-today': return 'today';
		case 'camera': return 'photo_camera';
		case 'cancel': return 'block';
		case 'cart': return 'shopping_cart';
		case 'category': return 'category';
		case 'cellphone': return 'smartphone';
		case 'chart': return 'bar_chart';
		case 'check': return 'check';
		case 'check-bold': return 'check';
		case 'checkbox-blank-circle-outline': return 'radio_button_unchecked';
		case 'checkbox-blank-outline': return 'check_box_outline_blank';
		case 'checkbox-marked': return 'check_box';
		case 'checkbox-marked-circle': return 'check_circle';
		case 'clock': return 'schedule';
		case 'clock-alert-outline': return 'schedule';
		case 'close': return 'close';
		case 'cloud': return 'cloud';
		case 'code-tags': return 'code';
		case 'console': return 'code';
		case 'coffee': return 'coffee';
		case 'devices': return 'devices';
		case 'devices-variant': return 'devices';
		case 'earth': return 'public';
		case 'edit': return 'edit';
		case 'email': return 'email';
		case 'ethernet-cable': return 'cable';
		case 'eye': return 'visibility';
		case 'file': return 'insert_drive_file';
		case 'flag': return 'flag';
		case 'folder': return 'folder';
		case 'heart': return 'favorite';
		case 'keyboard': return 'keyboard';
		case "key": return "vpn_key";
		case "key-minus": return "vpn_key";
		case "key-plus": return "vpn_key";
		case "language": return "language";
		case "laptop": return "laptop";
		case "layers": return "layers";
		case "location": return "location_on";
		case "lock": return "lock";
		case "magic": return "auto_fix_high";
		case "memory": return "memory";
		case "monitor": return "desktop_windows";
		case "mouse": return "mouse";
		case "office-building": return "apartment";
		case "open_in_new": return "open_in_new";
		case "link": return "link";
		case "image": return "image";
		case "paperclip": return "attach_file";
		case "plus": return "add";
		case 'power-plug': return 'power';
		case 'printer': return 'print';
		case 'resize-full': return 'fullscreen';
		case 'robot-industrial': return 'precision_manufacturing';
		case 'sd': return 'sd_card';
		case 'security': return 'security';
		case 'server': return 'storage';
		case 'server-network': return 'storage';
		case 'settings': return 'settings';
		case 'sim': return 'sd_card';
		case 'software': return 'api';
		case "star-full": return "star";
		case "stop": return "stop";
		case "tablet": return "tablet_android";
		case "television": return "tv";
		case "trash": return "delete";
		case "trash-x": return "delete_forever";
		case "upload": return "upload";
		case "usb": return "usb";
		case "user-group": return "groups";
		case "view-column": return "view_column";
		case "view_module": return "view_column";
		case "web": return "language";
		case "wifi": return "wifi";
		case "wlan_router": return "router";
		default:
			console.warn('Not found icon ' + logPlusIcon)
			return "";
	}
}